<template>
  <el-container>
    <el-aside>
      <div class="system-profile">
        <img src="https://oss.huarendjk.com/img/2023-08-03/64cb63a3e906d.png" alt="">
        <span style="margin-left: 10px;">爱康灵企康智能管理系统</span>
      </div>
      <div class="user-profile">
        <div style="width: 40px;">
          <el-avatar :src="userAvatar" size="small"></el-avatar>
        </div>
        <span style="margin-left: 10px;">{{ userName }}</span>
      </div>
      <el-menu router :default-active="activeRoute" text-color="#FFF" active-text-color="#409eff"
        background-color="#304156">
        <SidebarItem v-for="menu in menuData" :key="menu.name" :menu-item="menu"></SidebarItem>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header class="header">
        <h3>{{ curMenuName }}</h3>
        <el-popconfirm title="确定退出登录吗？" @confirm="handleLogOut">
          <el-button slot="reference" size="mini" class="el-icon-switch-button"></el-button>
        </el-popconfirm>
      </el-header>

      <el-main class="main">
        <transition name="fade-transform" mode="out-in">
          <keep-alive>
            <router-view :key="activeRoute"></router-view>
          </keep-alive>
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  import SidebarItem from './components/SidebarItem.vue'

  import menuData from '../menu'
  import {
    clearLoginInfo
  } from '@/utils/common-fun'

  export default {
    components: {
      SidebarItem
    },
    data() {
      return {
        userAvatar: '',
        userName: '',
        menuData,
      }
    },
    computed: {
      activeRoute() {
        return this.$route.path
      },
      curMenuName() {
        let data = menuData.filter(item => item.path == this.activeRoute)
        return data[0] ? data[0].title : '页面'
      }
    },
    created() {
      this.userAvatar = sessionStorage.getItem('userAvatar')
      this.userName = sessionStorage.getItem('userName')
    },
    methods: {
      // 退出登录
      handleLogOut() {
        clearLoginInfo()
        this.$router.replace('/login')
      }
    }
  }
</script>

<style scoped lang="less">
  .fade-transform-leave-active,
  .fade-transform-enter-active {
    transition: all .3s;
  }

  .fade-transform-enter {
    opacity: 0;
    transform: translateX(-20px);
  }

  .fade-transform-leave-to {
    opacity: 0;
    transform: translateX(20px);
  }

  .el-container {
    height: 100vh;
  }

  .el-header {
    background: #B3C0D1;
    color: #333;
    line-height: 60px;
  }

  .el-aside {
    width: 230px !important;
    color: #666;
    background: #304156;
  }

  .el-menu {
    border: 0 !important;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    background: #FFF;
    box-shadow: 1px 1px 2px #CCC;
    z-index: 10;
  }

  .profile {
    display: flex;
    align-items: center;
    color: #FFF;
    padding: 20px;
  }

  .system-profile {
    .profile();
    font-size: 18px;
  }

  .user-profile {
    .profile();
    padding: 10px 20px;
    font-size: 14px;
  }
</style>